import * as types from './Types'

const initialState = {
    loadedPinCode: {},
    selectedProduct: {},
    AllOccupation: {},
    AllEducation: [],
    MemberOccupation: {},
    getAllRelations: {},
    getAllState: {},
    getCityBasedOnState: [],
    PolicyDetails: {},
    familyDetails: {},
    storeAddQuotes: {},
    loadQuotes: [],
    QuotesResponse: [],
    notQuotesData: [],
    getMedical: [],
    proposerData: {},
    insuredMember: {},
    CommAddress: {},
    RefundPolicy: {},
    proposerRes: {},
    coverBenefit: {},
    nivabhupaKycResp: {},
    NivabhupaValue: {},
    chooseAddons: {},
    addOns: {},
    insurerList: {},
    getNomineeRelations: [],
    SbiKyc: [],
    CareKycRes: [],
    IciciKycRes: [],
    KycResponse: {},
    HdfcKycRes: [],
    genricOccupation: [],
    getGenericKycRes: [],
    loading: true
}

export const HealthReducers = (state = initialState, action) => {
    const { type, payload } = action
    switch (type) {
        case types.LOAD_ALL_PINCODE: return {
            ...state,
            loadedPinCode: payload,
            loading: false
        }

        case types.FAMILY_STORE: return {
            ...state,
            familyDetails: payload,
            loading: false
        }
        case types.GET_ALL_GENRIC_OCCUPATIONS: return {
            ...state,
            genricOccupation: payload,
            loading: false
        }
        case types.HEALTH_QUOTES_STORE: return {
            ...state,
            storeAddQuotes: payload,
            loading: false
        }

        // case types.GET_HEALTH_QUOTES: return {
        //     ...state,
        //     loadQuotes: payload,
        //     loading: false
        // }
        // case types.HEALTH_QUOTES_RESP: return {
        //     ...state,
        //     QuotesResponse: payload,
        //     loading: false
        // }

        case types.GET_HEALTH_QUOTES: {
            const incomingQuotes = Array.isArray(action.payload) ? action.payload : []
            const merged = [...state.loadQuotes]

            incomingQuotes.forEach((quote) => {
                if (!quote || !quote.insurerId) return

                const existingIndex = merged.findIndex(q => q.basePremium === quote.basePremium)

                if (existingIndex >= 0) {
                    merged[existingIndex] = quote
                } else {
                    merged.push(quote)
                }
            })

            return {
                ...state,
                loadQuotes: merged,
                loading: false
            }
        }

        case types.NOT_GET_QUOTES:
            const updatedQuotesMap = new Map()
            state.notQuotesData?.forEach(item => updatedQuotesMap.set(item.insurerLogo, item))
            action.payload.forEach(item => updatedQuotesMap.set(item.insurerLogo, item))
            const noUpdatedQuotesData = Array.from(updatedQuotesMap.values())
            return {
                ...state,
                notQuotesData: noUpdatedQuotesData,
                loading: false
            }

        case types.SELECTED_PRODUCT_ADDED: return {
            ...state,
            selectedProduct: payload,
            loading: false
        }
        case types.ADDONS_STORE: return {
            ...state,
            addOns: payload,
            loading: false
        }
        // Nivabhupa
        case types.NIVABHUPA_QUOTES_VALUE: return {
            ...state,
            NivabhupaValue: payload,
            loading: false
        }
        case types.NIVABHUPA_KYC_RESPONSE_STORE: return {
            ...state,
            nivabhupaKycResp: payload,
            loading: false
        }
        case types.SELECTED_ADDONS: return {
            ...state,
            chooseAddons: payload,
            loading: false
        }
        // End Stored Data 
        case types.EMPTY_NIVABHUPA_DATA:
            return {
                ...state,
                nivabhupaKycResp: null,
                NivabhupaValue: initialState.NivabhupaValue,
                coverBenefit: initialState.coverBenefit,
                addOns: null
            }

        case types.GET_HEALTH_PROPOSAL: return {
            ...state,
            proposerRes: payload,
            loading: false
        }
        case types.POLICY_DETAILS_ADDED: return {
            ...state,
            PolicyDetails: payload,
            loading: false
        }
        case types.COVERED_BENEFITS: return {
            ...state,
            coverBenefit: payload,
            loading: false
        }
        case types.GET_ALL_MEMBER_OCCUPATION: return {
            ...state,
            MemberOccupation: payload,
            loading: false
        }
        case types.GET_ALL_HEALTH_OCCUPATIONS: return {
            ...state,
            AllOccupation: payload,
            loading: false
        }
        case types.GET_ALL_MEMBER_EDUCATION: return {
            ...state,
            AllEducation: payload,
            loading: false
        }
        case types.GET_ALL_MEDICAL: return {
            ...state,
            getMedical: payload,
            loading: false
        }
        case types.GET_ALL_HEALTH_RELATION: return {
            ...state,
            getAllRelations: payload,
            loading: false
        }
        case types.GET_NOMINEE_RELATIONS_INSURERID: return {
            ...state,
            getNomineeRelations: payload,
            loading: false
        }
        case types.GET_ALL_HEALTH_STATE: return {
            ...state,
            getAllState: payload,
            loading: false
        }
        case types.GET_ALL_HEALTH_CITY: return {
            ...state,
            getCityBasedOnState: payload,
            loading: false
        }
        // Stored Data 
        case types.PROPOSER_DETAILS: return {
            ...state,
            proposerData: payload,
            loading: false
        }
        case types.INSURED_MEMBER: return {
            ...state,
            insuredMember: payload,
            loading: false
        }
        case types.COMMUNICATION_ADDRES: return {
            ...state,
            CommAddress: payload,
            loading: false
        }
        case types.REFUND_POLICY_DETAILS: return {
            ...state,
            RefundPolicy: payload,
            loading: false
        }
        // case types.SBI_KYC_RES: return {
        //     ...state,
        //     SbiKyc: payload,
        //     loading: false
        // }
        // case types.CARE_KYC_RES: return {
        //     ...state,
        //     CareKycRes: payload,
        //     loading: false
        // }
        case types.ICICI_KYC_RES: return {
            ...state,
            IciciKycRes: payload,
            loading: false
        }
        case types.KYC_RESP_STORE: return {
            ...state,
            KycResponse: payload,
            loading: false
        }
        // case types.HDFC_KYC_RES: return {
        //     ...state,
        //     HdfcKycRes: payload,
        //     loading: false
        // }
        // case types.GENERIC_KYC_RESP: return {
        //     ...state,
        //     getGenericKycRes: payload,
        //     loading: false
        // }
        case types.ACTIVE_INSURER_LIST: return {
            ...state,
            insurerList: payload,
            loading: false
        }

        case types.EMPTY_LOCAL_SORE:
            return {
                ...state,
                loadedPinCode: initialState.loadedPinCode

            }

        case types.RESET_GET_QUOTES:
            return {
                ...state,
                loadQuotes: initialState.loadQuotes,
                notQuotesData: initialState.notQuotesData
            }

        // Proposal All Data Empty
        case types.PROPOSAL_ALL_DATA_EMPTY: return {
            ...state,
            loading: false,
            proposerRes: initialState,
            nivabhupaKycResp: null,
            getGenericKycRes: null,
            proposerData: null,
            insuredMember: null,
            CommAddress: null,
            RefundPolicy: null,
            SbiKyc: null,
            KycResponse: null,
            CareKycRes: null,
            IciciKycRes: null,
            HdfcKycRes: null,
            getCityBasedOnState: initialState.getCityBasedOnState
        }

        case types.STATE_CHANGE_EMPTY_CITY: return {
            ...state,
            getCityBasedOnState: initialState.getCityBasedOnState
        }
        case types.PROPOSAL_LOCAL_SORE: return {
            ...state,
            loading: false,
            // proposerRes: null,
            proposerData: null,
            insuredMember: null,
            RefundPolicy: null,
            CommAddress: null
        }

        default:
            return state
    }
}

export default HealthReducers